// ISO 3166-2:IN state & union-territory codes. The primary 2-letter codes
// used by the People page dropdown and the compact pill in the list view.
export const INDIA_STATES = [
  // 28 States
  { code: "AP", name: "Andhra Pradesh" },
  { code: "AR", name: "Arunachal Pradesh" },
  { code: "AS", name: "Assam" },
  { code: "BR", name: "Bihar" },
  { code: "CG", name: "Chhattisgarh" },
  { code: "GA", name: "Goa" },
  { code: "GJ", name: "Gujarat" },
  { code: "HR", name: "Haryana" },
  { code: "HP", name: "Himachal Pradesh" },
  { code: "JH", name: "Jharkhand" },
  { code: "KA", name: "Karnataka" },
  { code: "KL", name: "Kerala" },
  { code: "MP", name: "Madhya Pradesh" },
  { code: "MH", name: "Maharashtra" },
  { code: "MN", name: "Manipur" },
  { code: "ML", name: "Meghalaya" },
  { code: "MZ", name: "Mizoram" },
  { code: "NL", name: "Nagaland" },
  { code: "OD", name: "Odisha" },
  { code: "PB", name: "Punjab" },
  { code: "RJ", name: "Rajasthan" },
  { code: "SK", name: "Sikkim" },
  { code: "TN", name: "Tamil Nadu" },
  { code: "TG", name: "Telangana" },
  { code: "TR", name: "Tripura" },
  { code: "UP", name: "Uttar Pradesh" },
  { code: "UK", name: "Uttarakhand" },
  { code: "WB", name: "West Bengal" },
  // 8 Union Territories
  { code: "AN", name: "Andaman & Nicobar Islands" },
  { code: "CH", name: "Chandigarh" },
  { code: "DN", name: "Dadra & Nagar Haveli and Daman & Diu" },
  { code: "DL", name: "Delhi" },
  { code: "JK", name: "Jammu & Kashmir" },
  { code: "LA", name: "Ladakh" },
  { code: "LD", name: "Lakshadweep" },
  { code: "PY", name: "Puducherry" },
];

export const STATE_NAME_BY_CODE = Object.fromEntries(INDIA_STATES.map((s) => [s.code, s.name]));

// Normalise legacy free-text location values (e.g. "Mumbai", "MIRA ROAD") to
// the matching state code where possible. Falls back to the raw value if no
// match — the UI then renders the first 2-3 chars uppercase as a best-effort
// pill so the column never breaks.
const CITY_TO_STATE = {
  mumbai: "MH", pune: "MH", nagpur: "MH", nashik: "MH", thane: "MH", "navi mumbai": "MH", "mira road": "MH", aurangabad: "MH",
  delhi: "DL", "new delhi": "DL", noida: "UP", gurgaon: "HR", gurugram: "HR", faridabad: "HR",
  bangalore: "KA", bengaluru: "KA", mysore: "KA", mangalore: "KA", blr: "KA",
  chennai: "TN", coimbatore: "TN", madurai: "TN",
  hyderabad: "TG", warangal: "TG",
  kolkata: "WB", howrah: "WB", siliguri: "WB", malda: "WB",
  ahmedabad: "GJ", surat: "GJ", vadodara: "GJ", rajkot: "GJ",
  jaipur: "RJ", jodhpur: "RJ", udaipur: "RJ", mandewal: "RJ",
  lucknow: "UP", kanpur: "UP", agra: "UP", varanasi: "UP", ghaziabad: "UP",
  patna: "BR",
  bhopal: "MP", indore: "MP", gwalior: "MP",
  chandigarh: "CH",
  kochi: "KL", trivandrum: "KL", thiruvananthapuram: "KL", kozhikode: "KL",
  visakhapatnam: "AP", vijayawada: "AP", guntur: "AP",
  bhubaneswar: "OD", cuttack: "OD",
  ranchi: "JH", jamshedpur: "JH",
  raipur: "CG",
  amritsar: "PB", ludhiana: "PB",
  dehradun: "UK", haridwar: "UK",
  guwahati: "AS", lonavala: "MH",
  panaji: "GA",
};

const STATE_NAME_TO_CODE = Object.fromEntries(INDIA_STATES.map((s) => [s.name.toLowerCase(), s.code]));

export function normaliseLocation(raw) {
  if (!raw) return "";
  const upper = String(raw).toUpperCase().trim();
  // Already a valid 2-letter state code
  if (STATE_NAME_BY_CODE[upper]) return upper;
  // Lookup by full state name (e.g. "Assam" → "AS")
  const lower = String(raw).toLowerCase().trim();
  if (STATE_NAME_TO_CODE[lower]) return STATE_NAME_TO_CODE[lower];
  // Lookup by city / common alias
  if (CITY_TO_STATE[lower]) return CITY_TO_STATE[lower];
  return raw; // free-text fallback
}

export function locationPill(raw) {
  if (!raw) return null;
  const code = normaliseLocation(raw);
  // If matched a known state, return the 2-letter code + full name for tooltip.
  if (STATE_NAME_BY_CODE[code]) return { code, label: STATE_NAME_BY_CODE[code], known: true };
  // Free-text fallback — show first 3 chars uppercase, full text on hover.
  return { code: String(raw).slice(0, 3).toUpperCase(), label: raw, known: false };
}
